<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="modal-header">
  <h1 class="chargebacktitle">Confirm Chargeback Collection</h1>
</div>
<table class="table table-bordered table-striped">
  <tbody>
    <tr>
      <td>Merchant name</td>
      <td>{{ chargeback.merchant.merchantName }}</td>
    </tr>
    <tr>
      <td>Merchant ID</td>
      <td>{{ chargeback.merchant.id }}</td>
    </tr>
    <tr>
      <td>Transaction ID</td>
      <td>{{ chargeback.details.parentExternalTransactionId }}</td>
    </tr>
    <tr>
      <td>Order ID</td>
      <td>{{ chargeback.details.orderId }}</td>
    </tr>
    <tr>
      <td>Chargeback Amount</td>
      <td>${{ chargeback.details.chargebackAmount }}</td>
    </tr>
    <tr>
      <td>Chargeback Fee</td>
      <td>{{ chargeback.details.chargebackFee | currency }}</td>
    </tr>
    <tr>
      <td><b>Total</b></td>
      <td>
        <b>{{ chargeback.details.chargebackTotal | currency }}</b>
      </td>
    </tr>
  </tbody>
</table>
<div class="modal-footer">
  <div *ngIf="actionInProgress">
    <div>
      <app-load-spinner></app-load-spinner>
    </div>
  </div>
  <button
    class="btn btn-success"
    type="button"
    (click)="submit()"
    [disabled]="actionInProgress"
  >
    Submit
  </button>
  <button
    class="btn btn-danger"
    type="button"
    (click)="cancel()"
    [disabled]="actionInProgress"
  >
    Cancel
  </button>
</div>
